import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.786 9.5h11.428a4.571 4.571 0 0 1 4.572 4.571v6.858a4.571 4.571 0 0 1-4.572 4.571H11.786a4.571 4.571 0 0 1-4.572-4.571V14.07A4.571 4.571 0 0 1 11.786 9.5Zm9.143 8-5.715-3.429v6.858l5.714-3.429Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgYoutube;